/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit, OnDestroy {

  private readonly destroy$ = new Subject<void>();

  constructor(private analytics: AnalyticsService,
     private seoService: SeoService,
     private translate: TranslateService,
     private router: Router,
     @Inject(DOCUMENT) private doc: Document) {
    this.translate.setDefaultLang('cn');
    this.translate.use('cn');
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();

    const spinner = document.getElementById('nb-global-spinner');
    if (spinner) {
      spinner.style.display = 'none';
    }

    // 防御性修复（B-003）：CDK 的全局滚动锁（BlockScrollStrategy）残留在 <html> 上未被清除时
    // （某个 overlay 的 disable() 没跑到），路由切换时兜底清掉，避免新页面被裁切/顶部被 header 遮挡。
    // 仅在路由切换这一刻生效；若残留发生后用户不换页，当前页仍会保持被遮挡，直到下一次导航。
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      takeUntil(this.destroy$),
    ).subscribe(() => {
      this.clearStaleGlobalScrollBlock();
    });
  }

  private clearStaleGlobalScrollBlock(): void {
    const html = this.doc.documentElement;
    if (!html.classList.contains('cdk-global-scrollblock')) {
      return;
    }
    // 此刻确实有 overlay 打开着 → 这是正常的滚动锁，不能清除。
    if (this.doc.querySelector('.cdk-overlay-pane')) {
      return;
    }
    html.classList.remove('cdk-global-scrollblock');
    html.style.top = '';
    html.style.left = '';
    window.scrollTo(0, 0);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
